import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';
import ActDetailList from './actDetailList.vue';

formCreate.component('ActDetailList', ActDetailList);
export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      progressList: [],
      chooseAct: [],
      formFunctionCode: 'reconsideration_form',
      formParentCode: 'CRM20211011000002741',
      buttonText: {
        submit: '确定复议',
      },
    };
  },

  async created() {
    if (this.formConfig.row.id) {
      this.init();
    }
    if (this.formConfig && this.formConfig.row) {
      this.formRole = this.formConfig.row.formRole ? this.formConfig.row.formRole : '';
    }
  },

  methods: {
    // 签批前的提交方法
    async beforeSubmit(code) {
      if (code === 'BTN_004') { // 审批通过
        if (this.formRole !== 'update2') {
          return true;
        }
        const params = this.getFormData();
        if (params) {
          const url = '/tpm/tpmActReconsider/reconsiderApprovingUpdate';
          params.id = this.formConfig.row.actId || this.formConfig.row.id;
          const res = await request.post(url, params);
          if (res.success) {
            return true;
          }
          return false;
        }
        return false;
      }
      return true;
    },
    // 设置rule
    setRule(item) {
      const v = item;
      if (v.field !== 'workFlowKey' && v.field !== 'title' && v.field !== 'activityFileList' && v.field !== 'approveRemarks') {
        v.props.disabled = true;
      }

      if (v.field === 'workFlowKey') {
        v.options = this.formConfig.progressList;
        v.on = {
          change: (e) => {
            if (e) {
              this.setValue({
                workFlowKey: e,
              });
            } else {
              this.setValue({
                workFlowKey: null,
                workFlowName: null,
              });
            }
          },
          getLabel: (e) => {
            this.setValue({
              workFlowName: e,
            });
          },
        };
      }
      return v;
    },

    formComplete() {
      const actDetailList = this.getRule('actDetailList'); // 活动明细列表
      const passType = this.getRule('passType');
      if (this.formRole === 'update2') { // 角色为update可编辑
        passType.props.disabled = false;
      } else {
        passType.props.disabled = true;
      }
      if (this.formConfig.code === 'edit' || this.formConfig.code === 'add') {
        this.hiddenFields(true, 'passType');
      }

      actDetailList.props = {
        ...actDetailList.props,
        actCode: this.formConfig.row.actCode,
        code: this.formConfig.code,
      };
      // 活动明细列表
      actDetailList.on.change = (e) => {
        if (e) {
          this.chooseAct = e;
        }
      };
    },

    // 提交
    async submit() {
      const { row } = this.formConfig;
      if (this.chooseAct.length === 0) {
        this.$message.warning('请勾选明细后再复议');
        return;
      }
      const params = this.getFormData();
      if (!params) return false;
      const url = '/tpm/tpmActExt/reconsider';
      params.actType = 'project';
      params.actCode = this.formConfig.row.actCode;
      params.detailVos = this.chooseAct;
      if (row && row.id) {
        params.id = row.id;
      }
      const { success } = await request.post(url, params);
      if (success) {
        this.$message({
          type: 'success',
          message: '发起复议成功！',
        });
        this.$emit('onClose');
        this.$emit('onGetList');
      }
    },

    // 初始化数据
    async init() {
      const { row } = this.formConfig;
      const data = await request.get('/tpm/tpmActReconsider/query', { id: row.id }).then((res) => (res.success ? res.result : []));
      const actDetailList = this.getRule('actDetailList'); // 活动明细列表
      actDetailList.props = {
        code: this.formConfig.code,
      };
      actDetailList.value = data.detailVos || [];
      this.chooseAct = data.detailVos || [];
      this.setValue(data);
    },
  },
};
